// extracted by mini-css-extract-plugin
export default {"walletBox":"styles_walletBox__xK4i9"};